import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import React from 'react'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/issues',
)({
  component: RouteComponent,
  staticData: {
    breadcrumb: Breadcrumb,
  },
})

function RouteComponent() {
  return <Outlet />
}

function Breadcrumb() {
  return (
    <Link to={Route.fullPath} params={Route.useParams()}>
      Issues
    </Link>
  )
}
